import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { getAccessToken, removeToken } from '../token.service';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
const requester = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

requester.interceptors.request.use((config) => {
  const accessToken = getAccessToken();
  if (config?.headers) {
    config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : undefined;
  }
  return config;
});

requester.interceptors.response.use(
  function (response) {
    if (response?.data?.status === 'FAILED') {
      return Promise.reject({ error: true, message: response.data?.cause });
    }
    if (response?.data?.output) {
      try {
        response.data = JSON.parse(response.data.output);
      } catch (error) {
        return Promise.reject({ error: true, message: error, output: response.data.output });
      }
    }
    return response;
  },
  function (error) {
    if (error.response) {
      error.code = error.response.data?.statusCode;
      error.message = error.response.data?.message;
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Request error:', error.message);
    }

    if (error?.status === 401) {
      removeToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
// Define a custom baseQuery that uses your Axios instance
export interface AxiosBaseQueryArgs {
  url: string;
  method: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  headers?: AxiosRequestConfig['headers'];
}

export const axiosBaseQuery: BaseQueryFn<AxiosBaseQueryArgs, unknown, unknown> = async ({
  url,
  method,
  data,
  params,
  headers,
}) => {
  try {
    const result = await requester({
      url,
      method,
      data,
      params,
      headers,
    });
    return result;
  } catch (axiosError) {
    const err = axiosError as AxiosError;
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};
export default requester;
